// Import Actions
import _ from 'lodash';
import {
    SET_VM_CITY,
    TOGGLE_AUTH_MODAL_STATE,
    TOGGLE_SEARCH_MODAL_STATE,
    TOGGLE_CITY_MODAL_STATE,
    TOGGLE_SIDEMENU_STATE,
    SEARCHING_FOR_VENUES,
    SEARCH_FOR_VENUES,
    GET_RECENT_SEARCHES,
    SET_HEADER_POSITION,
    TOGGLE_SEARCH_MODAL_STATE_FOR_COMPARE_PAGE,
} from '../actions/HeaderActions';

// Initial State
const initialState = {
    selectedCity: 'gurgaon',
    isSearching: false,
    searchData: [],
    isAuthModalVisible: false,
    isSearchModalVisible: false,
    isSearchModalVisibleForComparePage: false,
    isCityModalVisible: false,
    isGetQuoteModalVisible: false,
    isSideMenuBarVisible: false,
    loginFormState: '',
    eventSearchUrl: '',
    recentSearches: [],
    isHeaderFixed: true,
};

const HeaderReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_HEADER_POSITION:
            return {
                ...state,
                isHeaderFixed: action.isHeaderFixed,
            };

        case GET_RECENT_SEARCHES:
            return {
                ...state,
                recentSearches: action.recentSearches,
            };

        case SET_VM_CITY:
            return {
                ...state,
                selectedCity: action.selectedCity,
            };

        case TOGGLE_AUTH_MODAL_STATE:
            return {
                ...state,
                isAuthModalVisible: action.isAuthModalVisible,
                loginFormState: action.loginFormState,
            };

        case TOGGLE_SEARCH_MODAL_STATE:
            return {
                ...state,
                isSearchModalVisible: action.isSearchModalVisible,
            };

        case TOGGLE_SEARCH_MODAL_STATE_FOR_COMPARE_PAGE:
            return {
                ...state,
                isSearchModalVisibleForComparePage: action.isSearchModalVisibleForComparePage,
            };

        case TOGGLE_CITY_MODAL_STATE:
            return {
                ...state,
                isCityModalVisible: action.isCityModalVisible,
            };

        case TOGGLE_SIDEMENU_STATE:
            return {
                ...state,
                isSideMenuBarVisible: action.isSideMenuBarVisible,
            };

        case SEARCHING_FOR_VENUES:
            return {
                ...state,
                isSearching: action.isSearching,
            };

        case SEARCH_FOR_VENUES:
            return {
                ...state,
                isSearching: action.isSearching,
                searchData: action.searchData,
            };

        default:
            return state;
    }
};

/* Selectors */
export const getSelectedCity = (state) => state.header.selectedCity;
// Export Reducer
export default HeaderReducers;
